import { React } from "@/imports-files/components/input";

export function AssessmentActionOptions(props)
{
  return (
        <div className='JobActionOptions Close'>
          {
            Object.keys(props.options).map((key,index) => {    
              return(
                <div key        =  {`JobsOption_${key}`} 
                  className       =  {`JobsOptionKeys ${props.row.can_modify ? '' : 'disabled'}`}
                  onClick         =  {(event) => {    
                                      event.stopPropagation();
                                      if(props.row.can_modify){
                                        props.performAssessmentAction(props.options[key]['action'],{ 
                                                            'row'                   :     props.row,
                                                            'setAssessmentList'     :     props.setAssessmentList,
                                                            'router'                :     props.router,
                                                            'key'                   :     props.options[key]['key'],
                                                            'setDatatableLoading'   :     props.setDatatableLoading,
                                                            'setApiError'           :     props.setApiError,
                                                            'setAssessmentDeleteModal' :  props.setAssessmentDeleteModal,
                                                            'setCurrentRow'         :     props.setCurrentRow,
                                                            'customToastrAction'    :     props.customToastrAction,  
                                                            'setAssessmentAction'   :     props.setAssessmentAction,
                                                            'setAssessmentCreateModal':   props.setAssessmentCreateModal            
                                                            }
                                                      )
                                       }
                                    }}> 
                        {props.options[key]['title']}
                </div>
              )
            })
          }     
        </div>
      );
}